import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import Loading from "../../components/loading";
import headerLayoutWrapper from "../../hoc/headerLayoutWrapper";
import {
  addCategory,
  getCategories,
  deleteCategory,
  updateCategory,
} from "../../services/services";
import { X } from "lucide-react";
import { confirmDelete } from "../../components/confirmDelete";

const Category = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(15);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [nameError, setNameError] = useState(false);
  const nameInputRef = useRef(null);

  const [newCategory, setNewCategory] = useState({
    name: "",
    status: "active",
  });

  const fetchCategories = async () => {
    const payload = { type: "item" };
    try {
      setLoading(true);
      const res = await getCategories(payload);
      console.log(res);
      if (res.data.status) {
        setCategories(res.data.response);
      }
    } catch (err) {
      toast.error("Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleAddCategory = async () => {
    if (!newCategory.name.trim()) {
      setNameError(true);
      toast.error("Category name is required");

      setTimeout(() => {
        nameInputRef.current?.focus();
      }, 0);

      return;
    }

    const payload = {
      name: newCategory.name,
      type: "item",
      status: newCategory.status,
    };

    try {
      if (editingId) {
        // Update category
        const res = await updateCategory(editingId, payload);
        if (res.data.status) {
          toast.success(res.data.message);
          setEditingId(null);
        }
      } else {
        // Add new category
        const res = await addCategory(payload);
        if (res.data.status) {
          const newCat = res.data.response;
          toast.success(`${newCat.name} added!`);
        }
      }
      setNewCategory({ name: "", status: "active" });
      setShowAddModal(false);
      fetchCategories();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to save category");
    }
  };

  // const handleUpdate = (cat) => {
  //   setEditingId(cat._id);
  //   setNewCategory({ name: cat.name, status: cat.status });
  //   setShowAddModal(true);
  // };

  const handleDelete = async (id, name) => {
    const isConfirm = await confirmDelete(` ${name}`);
    if (!isConfirm) return;
    try {
      const res = await deleteCategory(id);
      if (res.data.status) {
        toast.success(res.data.message);
        fetchCategories();
      }
    } catch (error) {
      toast.error("Cannot delete - used in Product");
    }
  };
  const closeModal = () => {
    setShowAddModal(false);
    setEditingId(null);
    setNewCategory({ name: "", status: "active" });
    setNameError(false);
  };

  if (loading && categories.length === 0) return <Loading />;

  return (
    <>
      <div id="main">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="custom-title mb-0">Product Categories</h4>
          <div>
            <button
              className="btn btn-primary"
              onClick={() => setShowAddModal(true)}
            >
              Add Category
              {/* <i className="bi bi-plus"></i>
              <span className="d-none d-md-inline ms-1"> Add Category</span> */}
            </button>
          </div>
        </div>

        <div className="card product-list-card shadow-sm">
          <div className="card-body p-0">
            {categories.length === 0 ? (
              <div className="text-center p-5">
                <i className="bi bi-tags display-1 text-muted"></i>
                <p className="py-4 text-gray-500">No categories yet.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table align-middle   mb-0">
                  <thead
                    className="table-light small text-muted"
                    style={{ color: "#0b2b6d" }}
                  >
                    <tr>
                      <th>S.No</th>
                      <th>Category Name</th>
                      <th>Status</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories.map((cat, i) => (
                      <tr key={cat._id}>
                        <td>{(page - 1) * limit + i + 1}</td>
                        <td className="fw-semibold">{cat.name}</td>
                        <td>
                          {cat.status == "active" ? (
                            <span className="badge bg-success">Active</span>
                          ) : (
                            <span className="badge bg-danger">In Active</span>
                          )}
                        </td>
                        <td className="text-center">
                          <div>
                            {/* <button
                              className="btn btn-light btn-sm shadow-sm text-primary border"
                              onClick={() => handleUpdate(cat)}
                            >
                              <i class="bi bi-pencil"></i>
                            </button> */}
                            <button
                              className="btn btn-light btn-sm shadow-sm text-danger border"
                              onClick={() => handleDelete(cat._id, cat.name)}
                              title="Delete"
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      {showAddModal && (
        <div
          className="modal d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editingId ? "Edit Category" : "Add Category"}
                </h5>
                <X onClick={closeModal} style={{ cursor: "pointer" }} />
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">
                    Category Name
                    <span className="text-danger ms-1">*</span>
                  </label>
                  <input
                    ref={nameInputRef}
                    type="text"
                    className={`form-control ${nameError ? "is-invalid" : ""}`}
                    value={newCategory.name}
                    onChange={(e) => {
                      setNewCategory({
                        ...newCategory,
                        name: e.target.value,
                      });
                      if (nameError) setNameError(false);
                    }}
                  />
                  {nameError && (
                    <div className="invalid-feedback">
                      Category name is required
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Status</label>
                  <select
                    className="form-select"
                    value={newCategory.status}
                    onChange={(e) =>
                      setNewCategory({
                        ...newCategory,
                        status: e.target.value,
                      })
                    }
                  >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleAddCategory}
                >
                  {editingId ? "Update Category" : "Add Category"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default headerLayoutWrapper(Category);
